export default function CommunityStyle({ communityStats, streak }) {
  const stats = communityStats || { completed_today: 0, milestones: { starting: 0, building: 0, dedicated: 0, legend: 0 }, total_users: 0, active_streakers: 0 };
  const myStreak = streak?.current_streak || 0;

  // Determine user's milestone
  const myMilestone = myStreak >= 100 ? "legend" : myStreak >= 30 ? "dedicated" : myStreak >= 7 ? "building" : myStreak > 0 ? "starting" : null;

  const milestoneConfig = [
    { key: "starting", emoji: "🌱", label: "Đang bắt đầu", range: "1–6 ngày", color: "#10B981", bg: "#10B98115" },
    { key: "building", emoji: "💪", label: "Thói quen mới", range: "7–29 ngày", color: "#3B82F6", bg: "#3B82F615" },
    { key: "dedicated", emoji: "🔥", label: "Kiên trì", range: "30–99 ngày", color: "#F59E0B", bg: "#F59E0B15" },
    { key: "legend", emoji: "🏆", label: "Huyền thoại", range: "100+ ngày", color: "#EF4444", bg: "#EF444415" },
  ];

  if (!communityStats) {
    return (
      <div style={{ textAlign: "center", padding: "40px 20px", color: "var(--text-muted)" }}>
        <div style={{ fontSize: "32px", marginBottom: "12px" }}>📡</div>
        <div style={{ fontSize: "14px" }}>Đang tải dữ liệu cộng đồng...</div>
      </div>
    );
  }

  return (
    <>
      {/* Hero: Completed Today */}
      <div style={{ background: "var(--bg-card)", border: "1px solid var(--border-secondary)", borderRadius: "20px", padding: "28px 20px", marginBottom: "16px", textAlign: "center", position: "relative", overflow: "hidden", boxShadow: "var(--card-shadow)" }}>
        <div style={{ position: "absolute", inset: 0, background: "radial-gradient(circle at 50% 30%, #3B82F610, transparent 70%)", pointerEvents: "none" }} />
        <div style={{ fontSize: "48px", marginBottom: "8px" }}>🌍</div>
        <div style={{ fontSize: "36px", fontWeight: "900", color: "#2563EB", lineHeight: 1 }}>
          {stats.completed_today}
        </div>
        <div style={{ fontSize: "14px", color: "#2563EB", fontWeight: "600", marginTop: "6px" }}>
          người đã hoàn thành thử thách hôm nay
        </div>
        {stats.completed_today > 0 && (
          <div style={{ fontSize: "12px", color: "var(--text-tertiary)", marginTop: "8px", fontStyle: "italic" }}>
            {myStreak > 0 ? "Bạn là một trong số họ! ✨" : "Hãy tham gia cùng mọi người nhé!"}
          </div>
        )}
      </div>

      {/* Total Community */}
      <div style={{ display: "flex", gap: "12px", marginBottom: "16px" }}>
        <div style={{ flex: 1, background: "var(--bg-card)", border: "1px solid var(--border-secondary)", borderRadius: "16px", padding: "16px", textAlign: "center", boxShadow: "var(--card-shadow)" }}>
          <div style={{ fontSize: "24px", fontWeight: "800", color: "var(--text-primary)" }}>{stats.total_users}</div>
          <div style={{ fontSize: "11px", color: "var(--text-muted)", marginTop: "4px" }}>thành viên</div>
        </div>
        <div style={{ flex: 1, background: "var(--bg-card)", border: "1px solid var(--border-secondary)", borderRadius: "16px", padding: "16px", textAlign: "center", boxShadow: "var(--card-shadow)" }}>
          <div style={{ fontSize: "24px", fontWeight: "800", color: "#E68A00" }}>{stats.active_streakers}</div>
          <div style={{ fontSize: "11px", color: "var(--text-muted)", marginTop: "4px" }}>đang streak</div>
        </div>
      </div>

      {/* Streak Milestones */}
      <div style={{ background: "var(--bg-card)", border: "1px solid var(--border-secondary)", borderRadius: "20px", padding: "20px", marginBottom: "16px" }}>
        <div style={{ fontSize: "14px", fontWeight: "700", color: "var(--text-primary)", marginBottom: "16px", textAlign: "center" }}>
          👥 Cùng nhau trên hành trình
        </div>
        <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
          {milestoneConfig.map(m => {
            const count = stats.milestones[m.key] || 0;
            const isMyMilestone = m.key === myMilestone;
            return (
              <div key={m.key} style={{
                display: "flex", alignItems: "center", gap: "12px",
                background: isMyMilestone ? m.bg : "transparent",
                border: isMyMilestone ? `1px solid ${m.color}44` : "1px solid transparent",
                borderRadius: "12px", padding: "12px",
                transition: "all 0.3s",
              }}>
                <div style={{ fontSize: "28px", width: "40px", textAlign: "center" }}>{m.emoji}</div>
                <div style={{ flex: 1 }}>
                  <div style={{ fontSize: "13px", fontWeight: "700", color: isMyMilestone ? m.color : "var(--text-primary)" }}>
                    {m.label}
                    {isMyMilestone && <span style={{ fontSize: "10px", marginLeft: "6px", opacity: 0.8 }}>← Bạn đang ở đây!</span>}
                  </div>
                  <div style={{ fontSize: "11px", color: "var(--text-muted)" }}>{m.range}</div>
                </div>
                <div style={{ fontSize: "20px", fontWeight: "800", color: isMyMilestone ? m.color : "var(--text-muted)", minWidth: "36px", textAlign: "right" }}>
                  {count}
                </div>
                <div style={{ fontSize: "10px", color: "var(--text-muted)" }}>người</div>
              </div>
            );
          })}
        </div>
      </div>

      {/* Motivational Message */}
      <div style={{ background: "linear-gradient(135deg, var(--bg-card), var(--bg-card-alt))", border: "1px solid var(--border-secondary)", borderRadius: "16px", padding: "20px", textAlign: "center" }}>
        <div style={{ fontSize: "13px", color: "var(--text-muted)", lineHeight: 1.6, fontStyle: "italic" }}>
          {myStreak === 0 ? (
            "\"Đường đi nghìn dặm bắt đầu từ một bước chân. Hãy bắt đầu hôm nay — bạn không đơn độc.\""
          ) : myStreak < 7 ? (
            `"${stats.active_streakers} người đang cùng bạn trên hành trình này. Mỗi ngày một chút, cùng nhau tiến lên!"`
          ) : myStreak < 30 ? (
            `"Bạn đã ${myStreak} ngày rồi! Thói quen đang hình thành — và ${stats.active_streakers - 1} người khác cũng đang cố gắng như bạn."`
          ) : (
            `"${myStreak} ngày kiên trì! Bạn là nguồn cảm hứng cho cả cộng đồng."`
          )}
        </div>
      </div>
    </>
  );
}
